module.exports = __webpack_public_path__ + "assets/img/11_486.5b51124d.jpg";